export default __webpack_public_path__ + "static/media/story-telling1.d8a6f18a.png";